const SYMBOL_BY_CODE = {
  GBP: "£",
  USD: "$",
  BDT: "৳",
  CAD: "C$",
  EUR: "€",
};

/** Map API currency code or symbol to a display symbol (prefix). */
export function resolveCurrencySymbol(symbolOrCode, currencyType) {
  const fromType = String(currencyType || "").trim();
  const fromSymbol = String(symbolOrCode ?? "").trim();

  if (["£", "$", "৳", "€"].includes(fromSymbol)) {
    return fromSymbol;
  }

  const code = (fromSymbol || fromType || "GBP").toUpperCase();
  if (SYMBOL_BY_CODE[code]) {
    return SYMBOL_BY_CODE[code];
  }

  if (/^[A-Z]{3}$/i.test(fromSymbol)) {
    return SYMBOL_BY_CODE[fromSymbol.toUpperCase()] || "£";
  }

  return fromSymbol || "£";
}

/**
 * Format amount with currency symbol in front: "£ 185.00"
 * @param {number|string} amount
 * @param {string} symbolOrCode - e.g. "£", "GBP", or currencyTypes[].symbol
 * @param {{ currencyType?: string, decimals?: number, space?: boolean }} options
 */
export function formatCurrency(amount, symbolOrCode = "GBP", options = {}) {
  const { currencyType, decimals = 2, space = true } = options;
  const num = parseFloat(amount);
  const safeNum = Number.isFinite(num) ? num : 0;
  const symbol = resolveCurrencySymbol(symbolOrCode, currencyType);
  const formatted = Math.abs(safeNum).toFixed(decimals);
  const gap = space ? " " : "";

  if (safeNum < 0) {
    return `-${symbol}${gap}${formatted}`;
  }

  return `${symbol}${gap}${formatted}`;
}
